<template>
  <div class="arrows">
    <template v-if="artwork.media && artwork.media.length > 1">
      <tk-btn flat round aria-label="Previous button" class="prev-btn" @click="prev">
        <v-icon size="1.5rem">fas fa-chevron-left</v-icon>
      </tk-btn>
      <tk-btn flat round aria-label="Next button" class="next-btn" @click="next">
        <v-icon size="1.5rem">fas fa-chevron-right</v-icon>
      </tk-btn>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    artwork: { required: true },
  },
  methods: {
    prev(e) {
      e.stopPropagation();
      this.$emit("prev");
    },
    next(e) {
      console.log("next clicked");
      e.stopPropagation();
      this.$emit("next");
    },
  },
};
</script>

<style lang="scss" scoped>
.arrows {
  z-index: 1;
  button {
    position: absolute;
    min-width: auto;
    height: auto;
    margin: 0px;
    padding: 4px;
    background-color: rgba($color: #000000, $alpha: 0.4);
    color: #ffffff;
    width: 40px;
    height: 40px;
    &.prev-btn {
      left: 10px;
      top: 50%;
      transform: translateY(-50%);
    }
    &.next-btn {
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
}
</style>